import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faInstagram, faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import styles from '../css/comuns/Footer.module.css';
import { config } from '../../data';


const Footer = () => {
    return (
        <footer className={styles['footer']}>
            <div className={styles['footer-top']}>
                <div className={styles['logo-container1']}>
                    <img src={config.images.logos.main} alt={`${config.company.name} Logo`} className={styles['logo1']} />
                </div>
                <div className={styles['location-selector']}>
                    <label htmlFor="location">{config.texts.footer.location.label}</label>
                    <select id="location">
                        <option value="brejinho">{config.texts.footer.location.city}</option>
                    </select>
                </div>
                <div className={styles['social-media']}>
                    <label>{config.texts.footer.socialMedia.label}</label>
                    <div className={styles['social-icon-container']}>
                        <a href={config.links.social.facebook} className={styles['social-icon']} rel="noopener noreferrer">
                            <FontAwesomeIcon icon={faFacebookF} />
                        </a>
                        <a href={config.links.social.instagram} className={styles['social-icon']} rel="noopener noreferrer">
                            <FontAwesomeIcon icon={faInstagram} />
                        </a>
                        <a href={config.links.social.whatsapp} className={styles['social-icon']} rel="noopener noreferrer">
                            <FontAwesomeIcon icon={faWhatsapp} />
                        </a>
                    </div>
                </div>
            </div>
            <div className={styles['container']}>
                <div className={styles['footer-content']}>
                    <div className={styles['company-info']}>
                        <p>
                            {config.texts.footer.companyInfo.description}
                        </p>
                        <div className={styles['footer-buttons']}>
                            <div className={styles['btn-wrapper']}>
                                <a href={config.links.external.centralAssinante} className={styles['btn']}>{config.texts.footer.buttons.centralAssinante}</a>
                            </div>
                            <div className={styles['btn-wrapper']}>
                                <a href={config.links.external.recargaCelular} className={styles['btn']}>{config.texts.footer.buttons.recargaCelular}</a>
                            </div>
                            <div className={styles['btn-wrapper']}>
                                <a href={config.links.external.assineAgora} className={styles['btn-primary']}>{config.texts.footer.buttons.assineAgora}</a>
                            </div>
                        </div>
                    </div>
                    <div className={styles['footer-links']}>
                        <div className={styles['footer-column']}>
                            <h3>{config.texts.footer.columns.institucional.title}</h3>
                            <ul>
                                <li><a href="/Quem somos?">{config.texts.footer.columns.institucional.quemSomos}</a></li>
                                <li><a href="/Por que Oni?">{config.texts.footer.columns.institucional.porQue}</a></li>
                                <li><a href="/Blog">{config.texts.footer.columns.institucional.blog}</a></li>
                                <li><a href="/Contratos">{config.texts.footer.columns.institucional.contratos}</a></li>
                            </ul>
                        </div>
                        <div className={styles['footer-column']}>
                            <h3>{config.texts.footer.columns.planos.title}</h3>
                            <ul>
                                <li><a href="/Combos">{config.texts.footer.columns.planos.combos}</a></li>
                                <li><a href="/Internet">{config.texts.footer.columns.planos.internet}</a></li>
                                <li><a href="/Oni Play">{config.texts.footer.columns.planos.oniPlay}</a></li>
                                <li><a href="/Linha Móvel">{config.texts.footer.columns.planos.linhaMovel}</a></li>
                            </ul>
                        </div>
                        <div className={styles['footer-column']}>
                            <h3>{config.texts.footer.columns.contato.title}</h3>
                            <ul>
                                <li><a href="/Atendimento">{config.texts.footer.columns.contato.atendimento}</a></li>
                                <li><a href="/Ouvidoria">{config.texts.footer.columns.contato.ouvidoria}</a></li>
                                <li><a href="/Perguntas Frequentes">{config.texts.footer.columns.contato.faq}</a></li>
                            </ul>
                        </div>
                        <div className={styles['footer-column']}>
                            <h3>{config.texts.footer.columns.app.title}</h3>
                            <div className={styles['app-links']}>
                                <a href={config.links.external.googlePlay} rel="noopener noreferrer">
                                    <img src={config.images.logos.main} alt="App Store" />
                                </a>
                                <a href={config.links.external.googlePlay} rel="noopener noreferrer">
                                    <img src={config.images.logos.main} alt="Google Play" />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={styles['footer-bottom']}>
                <p>{config.texts.company.copyright}</p>
            </div>
        </footer>
    );
};

export default Footer;
